module.exports = __webpack_public_path__ + "static/media/hideAdsYear.2dcaef29.png";